import {
  Component,
  Input,
  OnInit,
  AfterViewInit,
  Pipe,
  PipeTransform,
  ElementRef,
  ViewChild,
} from "@angular/core";
import { DomSanitizer } from "@angular/platform-browser";
import { ActivatedRoute, Params, Router } from "@angular/router";
import { FormArray, FormBuilder, FormGroup, Validators } from "@angular/forms";
import { NgbModal, NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";

@Component({
  selector: "app-diagram-bpmn",
  templateUrl: "./diagram-bpmn.component.html",
  styleUrls: ["./diagram-bpmn.component.scss"],
})
export class DiagramBpmnComponent implements OnInit {
  @Input() url: any[] = [];

  constructor(
    private _router: Router,
    private _activatedRoute: ActivatedRoute,
    private fb: FormBuilder,
    private activeModal: NgbActiveModal,
    private sanitizer: DomSanitizer
  ) {}

  transform(url) {
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }

  ngOnInit() {}
}
